import DataImportFormTabs from '../../../components/3modules/DataImportFormTabs'
import PeopleImportTemplate from '../../../components/5templates/PeopleImportTemplate'
import { useNavigate } from 'react-router-dom'
import {useState} from 'react'
import {
    setItemToSessionStorage
} from '../../../services/util/sessionStorageManager'
import {areAllObjectValuesEmpty} from '../../../services/util/miscellaneousService'


const ImportPeopleForm = () => {
    const navigate = useNavigate()
    const [selectedContactList, setSelectedContactList] = useState({})
    const [isSnackbarOpen, setIsSnackbarOpen] = useState(false)
    const [organizationName, setOrganizationName] = useState('')
    const [organizationId, setOrganizationId] = useState('')

    const onNext = () => {
        if(!areAllObjectValuesEmpty(selectedContactList)){
            setItemToSessionStorage('newContact', selectedContactList)
            setItemToSessionStorage('organizationName', organizationName)
            setItemToSessionStorage('organizationId', organizationId)
            navigate('/addLocation/service')
        }else{
            setIsSnackbarOpen(true)
        }
    }

    const onPrev = () => {
        setItemToSessionStorage('newContact', selectedContactList)
        setItemToSessionStorage('organizationName', organizationName)
        setItemToSessionStorage('organizationId', organizationId)
        navigate('/addLocation/location')
    }


    return(
        <DataImportFormTabs flow={'addLocation'}>
            <PeopleImportTemplate selectedContactList={selectedContactList} setSelectedContactList={setSelectedContactList}
                                  onPrev={onPrev} onNext={onNext} organizationName={organizationName}
                                  setOrganizationName={setOrganizationName} organizationId={organizationId}
                                  setOrganizationId={setOrganizationId} formCheckSnackbar={isSnackbarOpen}
                                  setFormCheckSnackbar={setIsSnackbarOpen} />
        </DataImportFormTabs>
    )
}

export default ImportPeopleForm
